import { createReduxConstants } from '@bibliocommons/utils-redux';

export const actionTypes = createReduxConstants('ANALYTICS_GA4', {
  SET_SDK_CONFIG: null,
  TRACK_SDK_CHECKOUT_PLACE: null,
  TRACK_SDK_HOLD_PLACE: null,
  TRACK_SDK_LOG_IN: null,
  TRACK_SDK_USER_ACCOUNT_REGISTER: null,
  TRACK_PAGE_VIEW: null,
  TRACK_CONTENT_CLICK: null
});

export const eventNames = {
  CHECKOUT_PLACE: 'bc_checkout_place',
  CONTENT_CLICK: 'bc_content_click',
  HOLD_PLACE: 'bc_hold_place',
  PAGE_VIEW: 'bc_page_view',
  USER_ACCOUNT_REGISTER: 'bc_user_account_register',
  USER_LOG_IN: 'bc_user_log_in'
};

export default {
  actionTypes,
  eventNames
};
